var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.embededLink},[_c('script',{tag:"component",attrs:{"src":_vm.embededLink,"async":""}}),(!_vm.embededLink)?_c('div',{staticClass:"placeholder-code"},[_c('cv-button',{attrs:{"kind":"ghost"},on:{"click":function($event){return _vm.$emit('open-code')}}},[_vm._v(" Specify the branch to display a code snippet ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }